import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@topolo-io/design-tokens/tokens.css';
import '@topolo-io/onboarding/styles.css';
import '@topolo-io/tour/styles.css';
import './index.css';
import * as Sentry from '@sentry/react';
import { TopoloAppFatalErrorScreen } from '@topolo-io/app-shell';
import App from './App.tsx';
import { ErrorBoundary } from './components/ErrorBoundary.tsx';

// Initialize Sentry (conditional on DSN)
if (import.meta.env['VITE_SENTRY_DSN']) {
  Sentry.init({
    dsn: import.meta.env['VITE_SENTRY_DSN'],
    tracesSampleRate: 1.0,
    release: import.meta.env['VITE_APP_VERSION'] || 'dev',
    environment: import.meta.env['VITE_ENVIRONMENT'] || 'development',
  });
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Missing root element');

createRoot(rootElement).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<TopoloAppFatalErrorScreen appName='CRM' />}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </Sentry.ErrorBoundary>
  </StrictMode>
);
